export default __webpack_public_path__ + "static/media/SAMOre.256.5fd73eeb.png";